/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Store_1Inputs */

const en_bot_store_1 = /** @type {(inputs: Bot_Store_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A rewritten functional summary (features, flows, pricing, structure, detected technology), only in the plan of the user who asked.`)
};

const id_bot_store_1 = /** @type {(inputs: Bot_Store_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ringkasan fungsional yang ditulis ulang (fitur, alur, harga, struktur, teknologi yang terdeteksi), hanya untuk rencana milik pengguna yang meminta.`)
};

/**
* | output |
* | --- |
* | "A rewritten functional summary (features, flows, pricing, structure, detected technology), only in the plan of the user who asked." |
*
* @param {Bot_Store_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_store_1 = /** @type {((inputs?: Bot_Store_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Store_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_store_1(inputs)
	return en_bot_store_1(inputs)
});